import * as React from 'react';
import files from './files';
import { ClassName } from '../../utils/utils';

const cleanups: any[] = [
  /<title>.*<\/title>/gi,
  /<desc>.*<\/desc>/gi,
  /<!--.*-->/gi,
  / +width="\d+(\.\d+)?(px)?"/gi,
  / +height="\d+(\.\d+)?(px)?"/gi,
  / +fill=\"(none|#[0-9a-f]+)\"/gi,
  / +fill-opacity=\"([0-9]+)\"/gi,
  / +stroke-width=\"([0-9,.]+)\"/gi,
  / +stroke=\"(none|#[0-9a-f]+)\"/gi,
  / +sketch:type=\"MSShapeGroup\"/gi,
  / +sketch:type=\"MSPage\"/gi,
  / +sketch:type=\"MSLayerGroup\"/gi
];

interface ISvgProps {
  //   svg: string;
  name: string;
  type?: string;
}

export default class SVGIcon extends React.Component<ISvgProps> {
  public static cleanupSvg(svg: string) {
    cleanups.forEach(clean => {
      svg = svg.replace(clean, '');
    });
    return svg;
  }

  constructor(props: ISvgProps) {
    super(props);
  }

  public render() {
    const { name, type } = this.props;
    const icon = files[name] || name + '-icon';

    return null;
    
    // const svg = require(`../../../public/img/svg/${icon}.svg`);

    // return React.createElement('span', {
    //   style: {display: 'none!important'},
    //   className: ClassName('svg', [type]),
    //   dangerouslySetInnerHTML: {
    //     __html: SVGIcon.cleanupSvg(svg).replace(
    //       /<svg/,
    //       `<svg class="svg__${name}"`
    //       // + (fill ? ` fill="${fill}"` : ``) +
    //       // (width || height
    //       //   ? ` style="` +
    //       //     (width ? `width: ${width};` : ``) +
    //       //     (height ? `height: ${height};` : ``) +
    //       //     `"`
    //       //   : '')
    //     )
    //   }
    // });
  }
}



// WEBPACK FOOTER //
// ./src/modules/Svg/Svg.tsx